<pinch-zoom disableZoomControl="disable" backgroundColor="rgba(0,0,0,0)" class="w-full h-full">
	<img [src]="$file().data.fileUrl | https" (error)="onError()" />
</pinch-zoom>

@if ($showError()) {
	<div class="top-0 left-0 w-full h-full flex absolute items-center justify-center">
		<i class="icon-warning-white text-warn [font-size:100px]"></i>
	</div>
}
